import $ from 'jquery'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import base64 from 'vux/src/tools/base64/index.js'



let cosJson = function (fileName, SignParam) {

var cos = new CosCloud({
appid: '1251308557',
bucket: 'zb',
region: 'sh',



getAppSign: function (callback) {
if (SignParam === undefined) {

$.post(

'https://ai.4000073322.com//tregister/cos/getzbcossign', {
pathname: fileName
},
function (res) {
callback(res.data.sign)
},
'json'
)
} else {
callback(SignParam)
}
},
getAppSignOnce: function (callback) { }
})
return cos
}

/**
*
* @param {*} date 格林威治时间
* @param {string} type
* 'yyyy-MM-dd h:i:s'
* 'yyyy-MM-dd h:i'
* 'yyyy-MM-dd'
* 'yyyy-MM'
*/
let formatDate = function (date, type) {
let a
if (date !== undefined) {
a = new Date(date)
} else {
a = new Date()
}
var y = a.getFullYear()
var m = a.getMonth() + 1
m = m < 10 ? '0' + m : m
var d = a.getDate()
d = d < 10 ? '0' + d : d
var h = a.getHours()
var i = a.getMinutes()
var s = a.getSeconds()

h.toString().length === 1 ? (h = '0' + h) : ''

i.toString().length === 1 ? (i = '0' + i) : ''

s.toString().length === 1 ? (s = '0' + s) : ''
var result = ''
switch (type) {
case 'yyyy-MM':
result = y + '-' + m
break
case 'yyyy-MM-dd':
result = y + '-' + m + '-' + d
break
case 'yyyy-MM-dd h:i':
result = y + '-' + m + '-' + d + ' ' + h + ':' + i
break
case 'yyyy-MM-dd h:i:s':
result = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s
break
default:
result = y + '-' + m + '-' + d
break
}
return result
}
let random32 = function () {
var guid = ''
for (var i = 1; i <= 32; i++) {
var n = Math.floor(Math.random() * 16.0).toString(16)
guid += n
if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
}
return guid
}
let toThousand = function (num, isDecimal) {
if (isDecimal === undefined) isDecimal = 1
num = Number(num)
if (num > 999) {
num = num / 10000
num = (isDecimal ? num.toFixed(2) : num.toFixed(0)) + 'w'
} else {
num = isDecimal ? num.toFixed(2) : num.toFixed(0)
}
num = Number(num) === 0 ? 0 : num
return num
}
let getNextDay = function (num, date) {
var date1
if (date === undefined) {
date1 = new Date()
} else {
date1 = new Date(date)
}
var date2 = new Date(date1)
date2.setDate(date1.getDate() - num)
var time2 = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate()
return time2
}

let getNextMonth = function (num, date) {
var currentTime
if (date === undefined) {
currentTime = new Date()
} else {
currentTime = new Date(date)
}
var currentYear = currentTime.getFullYear()
var currentMonth = currentTime.getMonth() - 1
var currentDate = currentTime.getDate()
var futureDayNum = new Date(currentYear, currentMonth + num, 0).getDate()
var futureMonth = currentMonth + num
var futureDate

if (currentDate > futureDayNum) {
futureDate = futureDayNum
} else {
futureDate = currentDate
}

if (futureMonth > 12) {

futureMonth = futureMonth % 12
}
return currentYear + '-' + futureMonth + '-' + futureDate
}
let timestampToTime = (timestamp, format) => {
var date = new Date(timestamp)
var Y = date.getFullYear()
var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
var H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
format = format.indexOf('Y') > -1 ? format.replace('Y', Y) : format
format = format.indexOf('M') > -1 ? format.replace('M', M) : format
format = format.indexOf('D') > -1 ? format.replace('D', D) : format
format = format.indexOf('H') > -1 ? format.replace('H', H) : format
format = format.indexOf('m') > -1 ? format.replace('m', m) : format
format = format.indexOf('s') > -1 ? format.replace('s', s) : format
return format
}
/**
*
* @param {string} elementId  表格的id
* @param {string} fileName   导出表格的文件名
*/
let exportTable = function (elementId, fileName) {
if (fileName === undefined) fileName = '新建 XLSX 袋鼠先生工作表'
/* generate workbook object from table */

let table = document.querySelector(elementId).cloneNode(true)

if (table.querySelector('.el-table__fixed')) {
table.removeChild(table.querySelector('.el-table__fixed'))
table.removeChild(table.querySelector('.el-table__fixed-right'))
}
let wb = XLSX.utils.table_to_book(table, {
raw: true
})
wb.Sheets.Sheet1.width = 300
console.log(wb.Sheets)


/* get binary string as output */
var wbout = XLSX.write(wb, {
bookType: 'xlsx',
bookSST: true,
type: 'array'
})
try {
FileSaver.saveAs(
new Blob([wbout], {
type: 'application/octet-stream'
}),
fileName + '.xlsx'
)
} catch (e) {
if (typeof console !== 'undefined') console.log(e, wbout)
}
return wbout
}
/**
* @method
* 加密
*/
let encode = function (word) {
var randomString = Math.random()
.toString(36)
.substr(5)
return base64.encode(encodeURIComponent(base64.encode(word)) + randomString)
}

/**
* @method
* 解密
*/
let decode = function (word) {
word = base64.decode(word)
return base64.decode(decodeURIComponent(word.slice(0, word.length - 7)))
}
let commonFun = {
cosJson, // 加载腾讯云
formatDate, // 格林威治时间转字符串
random32,
toThousand,
getNextDay,
getNextMonth,
exportTable,
encode,
decode,
timestampToTime
}
export default commonFun



// WEBPACK FOOTER //
// ./src/common/common.js